import { Accessory } from '../../accessories/accessory.class';
import { Kitchen } from '../../kitchens/kitchen.class';

export type SyncAccessorySkuCountParams = {
	kitchen: Kitchen;
	sku: string;
	qualifyingCount: number;
};

/**
 * Additively syncs an accessory SKU count to match qualifying items — only adds missing
 * accessories, never removes. Persisted state is authoritative on load / duplicate / import;
 * a rule recount can never destroy a serialized accessory. Matches the existing add-only
 * pattern used for passthroughs / vents / insulated jackets: state wins on load, user removes
 * manually via the accessories UI.
 */
export const syncAccessorySkuCount = (params: SyncAccessorySkuCountParams): void => {
	const { kitchen, sku, qualifyingCount } = params;
	const { accessories } = kitchen;
	const existingCount = accessories.children.filter((s) => s.sku === sku).length;

	if (qualifyingCount > existingCount) {
		for (let i = 0; i < qualifyingCount - existingCount; i++) {
			const acc = new Accessory({ dataIn: { sku }, parent: accessories });
			accessories.children.push(acc);
		}
	}
};
